import CommonService from '../../services/CommonService';
const PrintPdfComponent = (props) => {
  const { proposedDebtDetails, proposeDebtDependencies } = props;

  return (
    <>
      <html lang="en">
        <head>
          <meta charset="UTF-8"></meta>
          <style>
            {
              "\
              div.repeat-header {\
                padding-top: 0.1in !important;\
                display: block !important;\
                text-align: center;\
                position: running(repeat-header) !important;\
              }\
              .report-header {\
                  text-align: center;\
                  padding: 5px;\
                  width: 100%;\
                  height: 40px;\
                  table-layout:fixed;\
                  border-collapse: collapse;\
            }\
              .report-heading-left {\
                  font-size: 18px;\
                  font-weight: 800;\
                  color: darkblue;\
                  text-align: left;\
                  width: 20%;\
              }\
               .report-heading-left figure {\
                  margin: 0;\
                  padding: 0;\
              }\
               .report-heading-center {\
                  font-size: 12px;\
                  font-weight: 800;\
                  color: darkblue;\
                  text-align: center;\
                  width: 60%;\
                  white-space: normal;\
                  overflow-wrap: break-word;\
            }\
              .report-heading-right {\
                  font-size: 12px;\
                  font-weight: 800;\
                  color: darkblue;\
                  text-align: right;\
                  width: 20%;\
                  white-space: nowrap;\
            }\
              .report-heading-center h1, .report-heading-center p, .report-heading-right p {\
                  margin: 0;\
                  padding: 0;\
            }\
              .report-heading-title {\
                 font-size: 18px;\
                 font-weight: 800;\
                 color: darkblue;\
                 text-align: left;\
                 min-width: 65%;\
             }\
              .report-heading-date {\
                  font-size: 10px;\
                  font-weight: 800;\
                  color: darkblue;\
                  text-align: right;\
              }\
              div.footer {\
                position: running(footer) !important;\
              }\
              #current-page-placeholder::before {\
                content: counter(page);\
              }\
              #total-pages-placeholder::before {\
                content: counter(pages);\
              }\
              @page {\
                  margin-top: 90px;\
                  @top-center {\
                      content: element(repeat-header) !important;\
                  }\
              }\
              @page {\
                  @bottom-right {\
                      content: element(footer) !important;\
                      font-size: 10px;\
                  }\
              }\
              div.repeat-header table {\
                  page-break-inside: avoid;\
              }\
              div.repeat-header tr {\
                  page-break-inside: avoid;\
                  page-break-after: auto\
              }\
              div.repeat-header thead {\
                  display: table-header-group\
              }\
              div.repeat-header tfoot {\
                  display: table-footer-group\
              }\
              div.break-page {\
                  page-break-after: always;\
              }\
              .table a {\
                  color: black;\
                  text-decoration: underline;\
              }\
              .table .tableheader th, .table tbody th {\
                  color: #fff;\
                  background-color: darkblue;\
                  border-color: #454d55;\
                  vertical-align: middle;\
                  font-size: 1.0em;\
              }\
              .v-top {\
                  vertical-align: top !important;\
              }\
              tr {\
                  page-break-inside: avoid\
              }\
              h2.info-subsection, h2.sub-heading {\
                  font-size: 13px;\
                  font-weight: bold;\
                  text-align: left;\
                  vertical-align: bottom;\
              }\
               .invoice-box{\
                max-width: 800px;\
                margin: auto;\
                padding: 20px;\
                border: 1px solid #eee;\
                box-shadow: 0 0 10px rgba(0, 0, 0, .15);\
                font-size: 13px;\
                line-height: 18px;\
                font-family: Helvetica, Arial, sans-serif;\
                color: #555;\
              }\
              .invoice-box table {\
                width: 100%;\
                line-height: inherit;\
                text-align: left;\
              }\
              .invoice-box table td {\
                padding: 5px;\
                vertical-align: top;\
              }\
            .border-top {\
                  border-top: 2px solid #eee;\
              }\
              .invoice-box table tr.top table td.title {\
                  font-size: 13px;\
                  line-height: 22px;\
                  color: #333;\
              }\
              .invoice-box table tr.information table td {\
                  padding-bottom: 10px;\
              }\
              .invoice-box table tr.heading td {\
                  border-bottom: 1px solid #ddd;\
                  font-weight: bold;\
              }\
              .invoice-box table tr.item td {\
                border-bottom: 1px solid #eee;\
              }\
              .invoice-box table tr.item.last td {\
                  border-bottom: none;\
              }\
              .invoice-box table tr.total {\
                  border-top: 2px solid #eee;\
                  font-weight: bold;\
              }\
              .invoice-box table tr.section-title td {\
                font-weight: bold;\
                font-size: 18px;\
                line-height: 18px;\
                color: #000;\
              }\
               .invoice-box .information table tr th {\
                padding-bottom: 10px;\
                vertical-align: bottom;\
                text-align: left;\
                font-weight: normal;\
            }\
                .invoice-box .information table tr td {\
                padding-bottom: 10px;\
                vertical-align: bottom;\
              }\
                .information {\
                text-align: left;\
                padding-bottom: 20px;\
              }\
                .invoice-box .information .section-title {\
                font-weight: bold;\
                font-size: 18px;\
                line-height: 18px;\
                color: #000;\
                padding-bottom: 20px;\
              }\
                .info-subsection {\
                padding-bottom: 10px;\
              }\
                .invoice-box .information table.info-subsection caption {\
                  text-align: left;\
              }\
                .fs-12 {\
                padding-bottom: 10px;\
              }\
                .invoice-box table tr.information table.data-table {\
                    border: 1px solid #ddd;\
              }\
                .invoice-box .information table.data-table {\
                border: 1px solid #ddd;\
              }\
                .invoice-box .information table.data-table tr.heading .th-left{\
                    text-align: left;\
              }\
                .invoice-box .information table.data-table tr.heading .th-right {\
                    text-align: right;\
              }\
                .invoice-box .information table.data-table th {\
                    text-align: left;\
              }\
              .invoice-box .information table tr.heading th {\
                border-bottom: 1px solid #ddd;\
                font-weight: bold;\
                vertical-align: bottom;\
                text-align: left;\
            }\
                .invoice-box table tr.information th {\
                padding-bottom: 10px;\
                vertical-align: bottom;\
                text-align: left;\
                font-weight: normal;\
            }\
                .invoice-box table tr.information td {\
                padding-bottom: 10px;\
                vertical-align: bottom;\
              }\
              @media only screen and (max-width: 600px) {\
              .invoice-box table tr.top table td {\
                  width: 100%;\
                  display: block;\
                  text-align: center;\
              }\
              .invoice-box table tr.information table td {\
                  width: 100%;\
                  display: block;\
                  text-align: center;\
              }\
              }\
            "
            }
          </style>
        </head>
        <body className="pdf-box">
          <div className="invoice-box">
            <div><p className="fs-12"><i>Report of Proposed Debt Issuance Information</i></p></div>
            <section className="information">
              <h1 className="section-title">Issuance</h1>
              <table>
                <tr><th>Issuer Name:</th><td align="right">{proposedDebtDetails.issuerName}</td></tr>
                <tr><th>Issue Name:</th><td align="right">{proposedDebtDetails.issueName}</td></tr>
                <tr><th>Project Name:</th><td align="right">{proposedDebtDetails.projectName}</td></tr>
                <tr><th>Proposed Sale Date:</th><td align="right">{CommonService.dateFormatter(proposedDebtDetails.proposedSaleDate)}</td></tr>
                <tr><th>Principal to be Sold:</th><td align="right">{CommonService.currencyFormatter(proposedDebtDetails.principalSaleAmt)}</td></tr>
                <tr><th>Is any portion of the principal to refund, redeem, paydown, or refinance outstanding debt?</th><td align="right">{proposedDebtDetails.refndRedeemPaydnRefinInd !== null ? (proposedDebtDetails.refndRedeemPaydnRefinInd === 'N' ? 'No' : 'Yes') : ''}</td></tr>
                {(proposedDebtDetails.refndRedeemPaydnRefinInd !== null && proposedDebtDetails.refndRedeemPaydnRefinInd === 'Y') &&
                  <tr><th>Refunding Amount:</th><td align="right">{CommonService.currencyFormatter(proposedDebtDetails.refndRedeemPaydnRefinAmt)}</td></tr>
                }

                {(proposedDebtDetails.refndRedeemPaydnRefinInd !== null && proposedDebtDetails.refndRedeemPaydnRefinInd === 'Y') &&
                  <tr>
                    <td colSpan="2">
                      <table>
                        <tr><td colSpan="2">CDIAC# of the debt to be refunded, redeemed, paid down, or refinanced: </td></tr>
                        <tr className="heading">
                          <th>CDIAC #</th>
                          <th>Amount</th>
                        </tr>
                        {proposeDebtDependencies.issueRefundAssocs.length > 0 ? proposeDebtDependencies.issueRefundAssocs.map((refundAssoc, i) => {
                          return (
                            <tr key={i}>
                              <td align="left">{refundAssoc.linkedCdiacNbr}</td>
                              <td align="left">{CommonService.currencyFormatter(refundAssoc.redeemAmt)}</td>
                            </tr>
                          )
                        }) :
                          <tr><td colspan="2">No data available to disaplay.</td></tr>
                        }
                      </table>
                    </td>
                  </tr>
                }

                <tr><th>Issuer certifies that it has complied with Gov. Code section 8855(i) with respect to local debt policies:</th><td align="right">{proposedDebtDetails.debtPolicyFlag !== null ? (proposedDebtDetails.debtPolicyFlag === 'N' ? 'No' : (proposedDebtDetails.debtPolicyFlag === 'Y' ? 'Yes' : 'Not Applicable')) : ''}</td></tr>

                {proposeDebtDependencies.issueSocEnvImpacts.length > 0 &&
                  <tr className="heading">
                    <th>
                      Environmental / Social Impact Type
                    </th>
                    <th>
                      Amount
                    </th>
                  </tr>
                }
                {proposeDebtDependencies.issueSocEnvImpacts.map((impact, i) => {
                  return (
                    <tr key={i}>
                      <td align="left">{impact.envSocImpactDisplayName}</td>
                      <td align="left">{CommonService.currencyFormatter(impact.envSocialImpactAmt)}</td>
                    </tr>
                  )
                })
                }

                <tr><th>Marks-Roos Authority/TRAN Pool Authority:</th><td>{proposedDebtDetails.marksRoosAuthorityInd !== null ? (proposedDebtDetails.marksRoosAuthorityInd === 'N' ? 'No' : 'Yes') : ''}</td></tr>

                <tr><th>Marks-Roos Local Obligor/TRAN Participant:</th><td>{proposedDebtDetails.marksRoosLocalObligInd !== null ? (proposedDebtDetails.marksRoosLocalObligInd === 'N' ? 'No' : 'Yes') : ''}</td></tr>
                {(proposedDebtDetails.marksRoosLocalObligInd !== null && proposedDebtDetails.marksRoosLocalObligInd === 'Y') &&
                  <tr>
                    <td colSpan="2">
                      <table>
                        <tr><td>CDIAC# of the related Authorities: </td></tr>
                        <tr className="heading">
                          <th>CDIAC #</th>
                        </tr>
                        {proposeDebtDependencies.issueMkrAuthAssocs.length > 0 ? proposeDebtDependencies.issueMkrAuthAssocs.map((mkrAuthAssoc, i) => {
                          return (
                            <tr key={i}>
                              <td align="left">{mkrAuthAssoc.authCdiacNbr}</td>
                            </tr>
                          )
                        }) :
                          <tr><td>No data available to disaplay.</td></tr>
                        }
                      </table>
                    </td>
                  </tr>
                }

              </table>
            </section>

            <section className="information">
              <h1 className="section-title">Issuance Authorization</h1>
              {proposeDebtDependencies.issueAuthorizations.map((auth, i) => {
                return (
                  <table>
                    <tr key={i}><td colspan="2"><h2 className="sub-heading">Authorization ({i + 1}):</h2></td></tr>
                    <tr><th>Authorization Name:</th><td align="right">{auth.authorizationName}</td></tr>
                    <tr><th>Original Authorized Amount:</th><td align="right">{CommonService.currencyFormatter(auth.originalAuthorizedAmt)}</td></tr>
                    <tr><th>Authorization Date (MM/DD/YYYY):</th><td align="right">{CommonService.dateFormatter(auth.authorizationDate)}</td></tr>
                    <tr><th>Amount Authorization Replenished (By this Issue):</th><td align="right">{CommonService.currencyFormatter(auth.authorityReplenishAmt)}</td></tr>
                    <tr><th>Amount Authorization Reduced (By this Issue):</th><td align="right">{CommonService.currencyFormatter(auth.authorityReducedAmt)}</td></tr>
                    <tr><th>Net Change (By this Issue):</th><td align="right">{CommonService.currencyFormatter(auth.authorityReplenishAmt - auth.authorityReducedAmt)}</td></tr>
                  </table>
                )
              })
              }
            </section>

            {/* Statutory Authority */}
            <section className="information">
              <h1 className="section-title">Statutory Authority</h1>
              <div>
                <table>
                  <tr><th>Will a Validation Action be Pursued?</th><td align="right">{proposedDebtDetails.validationActionFlag !== null ? (proposedDebtDetails.validationActionFlag === 'N' ? 'No' : 'Yes') : ''}</td></tr>
                </table>
              </div>

              <div>
                <h2 className="sub-heading">Statutory Authorities</h2>
                {proposeDebtDependencies.issueStatutes.length > 0 ? proposeDebtDependencies.issueStatutes.map((statute, i) => {
                  return (
                    <table>
                      <tr key={i}><th><b>Statute ({i + 1}): </b></th><td>&nbsp;</td></tr>

                      <tr><th>Statute:</th><td>{statute.displayStatuteName}</td></tr>
                      {statute.statuteId === 'OTH' &&
                        <>
                          <tr><th>Statute Code:</th><td>{statute.otherStatuteCode}</td></tr>
                          <tr><th>Statute Section:</th><td>{statute.otherStatuteText}</td></tr>
                          <tr><th>Statute Description:</th><td>{statute.otherStatuteBriefDesc}</td></tr>
                        </>}

                    </table>
                  )
                })
                  :
                  <div><p className="fs-12">No data available to display.</p></div>
                }
              </div>
            </section>

            {/* Tax Status/Interest */}
            <section className="information">
              <h1 className="section-title">Tax Status/Interest</h1>
              <table>
                <tr><th>Under State Law:</th><td align="right">{proposedDebtDetails.stateTaxFlag != null ? proposedDebtDetails.stateTaxFlag === "Y" ? "Taxable" : (proposedDebtDetails.stateTaxFlag === "N" ? "Tax-Exempt" : "Taxable, Tax-Exempt") : ''}</td></tr>
                <tr><th>Taxable Principal Amount:</th><td align="right">{CommonService.currencyFormatter(proposedDebtDetails.stateTaxPrincipalAmt)}</td></tr>
                <tr><th>Tax-Exempt Principal Amount:</th><td align="right">{CommonService.currencyFormatter(proposedDebtDetails.stateTaxExemptAmt)}</td></tr>
                <tr><th>Under Federal Law:</th><td align="right">{proposedDebtDetails.federalLawDisplayText}</td></tr>
                <tr><th>Taxable Principal Amount:</th><td align="right">{CommonService.currencyFormatter(proposedDebtDetails.federalTaxPrincipalAmt)}</td></tr>
                <tr><th>Tax-exempt (No AMT) Principal Amount:</th><td align="right">{CommonService.currencyFormatter(proposedDebtDetails.federalTaxExemptAmt)}</td></tr>
                <tr><th>Tax-exempt (AMT) Principal Amount:</th><td align="right">{CommonService.currencyFormatter(proposedDebtDetails.altMinTaxAmt)}</td></tr>
              </table>
            </section>

            {/* Type of debt instrument */}
            <section className="information">
              <h1 className="section-title">Type of Debt Instrument</h1>
              <div><p className="fs-12">{proposedDebtDetails.debtInstrumentName}</p></div>
            </section>

            {/* Source of Repayment */}
            <section className="information">
              <h1 className="section-title">Source of Repayment</h1>
              <table>
                <tr><th>Is debt repayable in non-US currency?</th><td align="right">{proposedDebtDetails.debtRepayNonUsCurrFlag ? (proposedDebtDetails.debtRepayNonUsCurrFlag === 'N' ? 'No' : (proposedDebtDetails.debtRepayNonUsCurrFlag === 'Y' ? 'Yes' : 'Unknown')) : ''}</td></tr>
                <tr className="heading">
                  <th colspan="2">Source of Repayment Type:</th>
                </tr>
                {proposeDebtDependencies.issueRepaymentSources.length > 0 ?
                  proposeDebtDependencies.issueRepaymentSources.map((source, i) => {
                    return (
                      <tr key={i}><td colspan="2" align="left">{source.displayName}{source.repymtSrcCodeValueCode === "OTHS" && (" (" + source.otherText + ")")}</td></tr>
                    )
                  }) :
                  <tr><td colspan="2">No data available to display.</td></tr>
                }
              </table>
            </section>

            {/* Purpose of Financing */}
            <section className="information">
              <h1 className="section-title">Purpose of Financing</h1>
              <table>
                <tr className="heading">
                  <th>
                    Purpose Name
                  </th>
                  <th>
                    Percentage
                  </th>
                </tr>
                {proposeDebtDependencies.issueFinancingPurposes.length > 0 ?
                  proposeDebtDependencies.issueFinancingPurposes.map((purpose, i) => {
                    return (
                      <tr key={i}>
                        <td align="left">{purpose.financePurposeName}</td>
                        <td align="left">{purpose.financePurposePct}</td>
                      </tr>
                    )
                  }) :
                  <tr><td colspan="2">No data available to disaplay.</td></tr>
                }
              </table>
            </section>

            {/* Financing participants */}
            <section className="information">
              <h1 className="section-title">Financing Participants</h1>
              {proposeDebtDependencies.issueContacts &&
                <table>
                  <tr className="heading">
                    <th>Role</th>
                    <th>Organization</th>
                    <th>Contact First Name</th>
                    <th>Contact Last Name</th>
                  </tr>
                  {proposeDebtDependencies.issueContacts.length > 0 ? proposeDebtDependencies.issueContacts.map((el, i) => {
                    return (
                      <tr><td align="left">{el.roleCodeDescription}</td><td align="left">{el.organizationName}</td><td align="left">{el.contactFirstName}</td><td align="left">{el.contactLastName}</td></tr>)
                  }) :
                    <tr><td colspan="4">No data available to display.</td></tr>
                  }
                </table>
              }
            </section>

            {/* Type of Sale */}
            <section className="information">
              <h1 className="section-title">Type of Sale</h1>
              <div>
                <table>
                  <tr><th>Type:</th><td align="right">{proposedDebtDetails.saleTypeCode && (proposedDebtDetails.saleTypeCode === "N" ? "Negotiated" : "Competitive")}</td></tr>
                  <tr><th>Is financing a private placement?</th><td align="right">{proposedDebtDetails.pvtPlacementFinanceInd && (proposedDebtDetails.pvtPlacementFinanceInd === "N" ? "No" : "Yes")}</td></tr>
                </table>
              </div>
              <div>
                {proposedDebtDetails.saleTypeCode && proposedDebtDetails.saleTypeCode === "N" &&
                  <h2 className="sub-heading">Reason(s) for Negotiated Sale:</h2>
                }
                {proposeDebtDependencies.issuePrivateSaleReasons.length > 0 ?
                  proposeDebtDependencies.issuePrivateSaleReasons.map((el, i) => {
                    return (
                      <p className="fs-12">{el.displayName}<br />{el.reasonOtherText && el.reasonOtherText}</p>)
                  })
                  :
                  <p className="fs-12">No data available to display.</p>
                }
              </div>
            </section>

            {/* Document Submittal */}
            <section className="information">
              <h1 className="section-title">Document Submittal</h1>
              <table>
                <tr className="heading">
                  <th>Document Type</th>
                  <th>Document Name</th>
                  <th>File Upload Date</th>
                </tr>
                {proposeDebtDependencies.issueDocuments.length > 0 ? proposeDebtDependencies.issueDocuments.map((document, i) => {
                  return (
                    <tr key={i}>
                      <td align="left">{document.documentDesc}</td>
                      <td align="left">{document.fileName}</td>
                      <td align="left">{CommonService.dateFormatter(document.createDatetime)}</td>
                    </tr>
                  )
                }) :
                  <tr><td colspan="3">No data available to disaplay.</td></tr>
                }
              </table>
            </section>

            <section>
              <table>
                {proposedDebtDetails.issueStatusFlag !== 'D' &&
                  <tr className="information"><th>Submission Date</th><td align="right">{CommonService.dateFormatter(proposedDebtDetails.filingDate)}</td></tr>
                }
                {proposedDebtDetails.issueStatusFlag === 'R' &&
                  <tr className="information"><th>Review Date</th><td align="right">{CommonService.dateFormatter(proposedDebtDetails.lastUpdateDatetime)}</td></tr>
                }
              </table>
            </section>
          </div>
        </body>
      </html>
    </>
  );
  //}
}

export default PrintPdfComponent;